import { Box, Button, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import Modal from 'modules/core/components/Modal'
import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useCompetencies } from 'modules/trainings/hooks/Trainings/useCompetencies'
import { UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

interface BlockProps {
  readonly: boolean
  form: FormikProps<UpdateData>
}

export const CompetenciesBlock = ({ readonly, form }: BlockProps) => {
  const [open, toggle] = useToggle()
  const { competencies } = useCompetencies()

  return competencies && competencies.length > 0 ? (
    <Box gap="s12">
      <Text size="200" color="grey1000" weight="medium">
        {i18n.t('trainings.training_requests.my_requests.detail.competencies_title')}
      </Text>
      <Box flexDirection="row" justifyContent="spaceBetween">
        {form.values.competencyIds.length > 0 ? (
          <Box flexDirection="row" gap="s12">
            {form.values.competencyIds.map((competencyId, index) => (
              <Tag type="grey" key={index}>
                {competencies.find((competency) => competency.id === competencyId)?.name}
              </Tag>
            ))}
          </Box>
        ) : (
          <Tag type="grey">
            {i18n.t('trainings.training_requests.my_requests.detail.competencies_empty')}
          </Tag>
        )}

        {!readonly && <Button type="secondary" onClick={toggle(!open)} iconName="pencil" />}
        {open && !readonly && (
          <Modal
            title={i18n.t('trainings.training_requests.my_requests.detail.selector_competencies')}
            onClose={toggle(false)}
          >
            <Selector.Container
              searchPlaceholder={i18n.t('common.search')}
              blankLabel=""
              value={form.values.competencyIds}
              onChange={(selection) =>
                form.setValues({ ...form.values, competencyIds: selection as string[] })
              }
              isMultiSelect
            >
              {competencies.map((competency) => {
                return (
                  <Selector.Option
                    key={competency.id}
                    value={competency.id}
                    label={competency.name}
                    searchValue={competency.name}
                  >
                    {competency.name}
                  </Selector.Option>
                )
              })}
            </Selector.Container>
          </Modal>
        )}
      </Box>
    </Box>
  ) : (
    <></>
  )
}
